const ActivityLogsPath = "/activity-logs";
export const ConfigurationPath = "/configuration";
export const ConfigurationActivityLogsPath = `${ConfigurationPath}${ActivityLogsPath}`;
export const FirmwaresPath = "/firmwares";
export const FirmwaresActivityLogsPath = `${FirmwaresPath}${ActivityLogsPath}`;
export const FeatureKeysPath = "/feature-keys";
export const FeatureKeysActivityLogsPath = `${FeatureKeysPath}${ActivityLogsPath}`;
export const LicensesPath = "/licenses";
export const LicensesActivityLogsPath = `${LicensesPath}${ActivityLogsPath}`;
export const VouchersPath = "/vouchers";
export const VouchersActivityLogsPath = `${VouchersPath}${ActivityLogsPath}`;
export const VoucherOverviewPath = "/vouchers-overview";
export const VoucherOverviewActivityLogsPath = `${VoucherOverviewPath}${ActivityLogsPath}`;
export const VoucherSearchPath = "/voucher-search";
export const UserManagementPath = "/user-management";
export const UserManagementActivityLogsPath = `${UserManagementPath}${ActivityLogsPath}`;

const ROUTES: any = {
  root: "/",
  configuration: ConfigurationPath,
  firmwares: FirmwaresPath,
  featureKeys: FeatureKeysPath,
  licenses: LicensesPath,
  vouchers: VouchersPath,
  voucherOverview: VoucherOverviewPath,
  voucherSearch: VoucherSearchPath,
  userManagement: UserManagementPath,
};

export default ROUTES;
